const TOKEN = 'GTSYS-TOKEN';

/**
 * Marca que o usuário já escolheu o tenant nesta sessão (T4.2). Vive aqui, e
 * não no service de tenant, porque tem exatamente o tempo de vida do token:
 * morre junto em todo caminho de logout e no 401 do interceptor. Guardado
 * fora do Token, sobrevivia ao logout e o próximo login na mesma aba entrava
 * sem passar pela seleção.
 */
const TENANT_OK = 'GTSYS-TENANT-OK';

/**
 * Empresa escolhida no switcher nesta aba. Mora aqui pelo mesmo motivo que o
 * TENANT_OK: morre junto com o token. É ela que faz a troca sobreviver ao
 * reload de `/app/home` sem virar preferência salva — preferência agora só se
 * define de propósito, marcando "entrar sempre nesta empresa".
 */
const TENANT_ATALHO = 'GTSYS-TENANT-D';

export default {
    key: TOKEN,

    get() {
        return sessionStorage.getItem(TOKEN);
    },

    getHeader() {
        let token = sessionStorage.getItem(TOKEN);
        return {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
    },

    remove() {
        sessionStorage.removeItem(TOKEN);
        sessionStorage.removeItem(TENANT_OK);
        sessionStorage.removeItem(TENANT_ATALHO);
    },

    set(token) {
        sessionStorage.setItem(TOKEN, token);
        // Token novo é sessão nova: sem isto, o login seguinte na mesma aba
        // herdava o "já escolhi" do usuário anterior e pulava a seleção.
        sessionStorage.removeItem(TENANT_OK);
        sessionStorage.removeItem(TENANT_ATALHO);
    },

    tenantSelecionado() {
        return sessionStorage.getItem(TENANT_OK) === '1';
    },

    marcarTenantSelecionado() {
        sessionStorage.setItem(TENANT_OK, '1');
    },

    tenantAtalho() {
        return sessionStorage.getItem(TENANT_ATALHO);
    },

    fixarTenantAtalho(slug) {
        sessionStorage.setItem(TENANT_ATALHO, slug);
    },
}
